import type { Message } from '@/types/message'
import { Icon } from '@/components/ui/Icon'
import { MessageContent } from './MessageContent'

export function BotAvatar({ avatarUrl }: { avatarUrl?: string | null }) {
  return avatarUrl
    ? <img src={avatarUrl} alt="Agent" className="cx-agent-avatar" />
    : <img src="/assets/cx-mark-v2.png" alt="CX Agent" className="cx-agent-avatar cx-agent-avatar-mark" />
}

export function ChatMessage({ m, onReact, onAction, avatarUrl, t }: {
  m: Message
  onReact: (id: string, reaction: 'like' | 'dislike') => void
  onAction: (id: string, value: string) => void
  avatarUrl?: string | null
  t: (key: string) => string
}) {
  if (m.role === 'user') {
    return <div className="cx-message cx-message-user"><div dir="auto" className="cx-user-bubble"><MessageContent content={m.content} citations={m.citations} /></div></div>
  }
  return (
    <div className="cx-message cx-message-agent">
      <BotAvatar avatarUrl={avatarUrl} />
      <div className="cx-agent-copy">
        <div dir="auto" className="cx-message-body">
          {m.isStreaming && !m.content
            ? <div role="status" aria-label="Assistant is thinking" aria-live="polite"><span className="cx-thinking" aria-label="Assistant is thinking"><span /><span /><span /></span></div>
            : <><MessageContent content={m.content} citations={m.citations} />{m.isStreaming && <span className="caret" />}</>}
        </div>
        {!m.isStreaming && m.actions && m.actions.length > 0 && (
          <div className="cx-actions">{m.actions.map((a, i) => (
            <button key={a.id} className={i === 0 ? 'cx-action-primary' : ''} onClick={() => onAction(a.id, a.value ?? a.label)}>{a.label}</button>
          ))}</div>
        )}
        {!m.isStreaming && m.kind !== 'acknowledgment' && m.id !== '__welcome__' && (
          <div className="cx-reactions">
            <button aria-label={t('chat.helpful')} data-tip={t('chat.helpful')} onClick={() => onReact(m.id, 'like')} className={m.reaction === 'like' ? 'active' : ''}><Icon name="thumbUp" size={14} aria-hidden="true" focusable="false" /></button>
            <button aria-label={t('chat.notHelpful')} data-tip={t('chat.notHelpful')} onClick={() => onReact(m.id, 'dislike')} className={m.reaction === 'dislike' ? 'active dislike' : ''}><Icon name="thumbDown" size={14} aria-hidden="true" focusable="false" /></button>
            <button aria-label={t('chat.copy')} data-tip={t('chat.copy')} onClick={() => navigator.clipboard?.writeText(m.content)}><Icon name="copy" size={14} aria-hidden="true" focusable="false" /></button>
          </div>
        )}
      </div>
    </div>
  )
}
